import { useClipboard } from '@reactuses/core';
import { Check, Copy } from 'lucide-react';
import { useEffect, useState } from 'react';

import { Button, Input, Label } from '@virtual-care/shadcn';

export function GeneratedPassword({
  generatedPassword,
}: {
  generatedPassword: string;
}) {
  const [, copy] = useClipboard();
  const [copied, setCopied] = useState(false);
  useEffect(() => {
    setTimeout(() => {
      setCopied(false);
    }, 1000);
  }, [copied]);

  return (
    <div className="space-y-2">
      <Label htmlFor="generatedPassword">Generated Password</Label>
      <div className="relative">
        <Input
          id="generatedPassword"
          type="text"
          value={generatedPassword}
          readOnly
          className="bg-muted pe-10"
        />
        <Button
          type="button"
          variant="ghost"
          size="sm"
          className="absolute top-0 h-full hover:bg-transparent ltr:right-0 rtl:left-0"
          aria-label={copied ? 'Copied password' : 'Copy password'}
          title={copied ? 'Copied!' : 'Copy'}
          onClick={(event) => {
            event.preventDefault();
            void copy(generatedPassword);
            setCopied(true);
          }}
        >
          {copied ? (
            <Check className="text-muted-foreground h-4 w-4" />
          ) : (
            <Copy className="text-muted-foreground h-4 w-4" />
          )}
        </Button>
      </div>
      <p className="text-muted-foreground text-sm">
        The password was emailed to the user automatically; copy it here if you
        need it.
      </p>
    </div>
  );
}
